"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eligibilityOverrideFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
const util_1 = require("../../util");
exports.eligibilityOverrideFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => uuid_1.v4()),
    persona_id: 1,
    rule_system: util_1.services.MembershipService,
    rule_type: util_1.resources.waiver,
    rule_value: Mocks.waiver.id,
    status: 'complete',
    reason: 'Test',
    created_at: Mocks.dates.date2000,
    created_by_user_id: 1,
    created_by_boss_organization_id: Mocks.orgNgb.id,
    created_by_boss_organization_name: Mocks.orgNgb.name,
    updated_at: Mocks.dates.date2000,
});
